/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * GetApplicationConnectionRedirectHandler.js--
 *
 *      inherited Class to handle <get-application-connection-redirect>
 */

import RedirectHandler from "./redirectHandler";

export default function GetApplicationConnectionRedirectHandler() {
   this.requestTag = "get-application-connection-redirect"; // the XML request tag name
   this.responseTag = "application-connection-redirect"; // the XML response tag name
}

// inherits RedirectHandler prototype
GetApplicationConnectionRedirectHandler.prototype = new RedirectHandler();

// constructor
GetApplicationConnectionRedirectHandler.constructor = GetApplicationConnectionRedirectHandler;
